import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({
  standalone: false,
  name: 'userInitials'
})
export class UserInitialsPipe implements PipeTransform {
  transform(user: any, defaultValue: string = 'NA'): string {
    const firstName = get(user, 'firstName');
    const lastName = get(user, 'lastName');

    if (!firstName || !lastName) {
      return defaultValue;
    }
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  }
}
